import Vue from 'vue';

import './styles/quasar.styl';
import lang from 'quasar/lang/pt-br';
import '@quasar/extras/material-icons/material-icons.css';
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QMarkupTable,
  QItemSection,
  QItemLabel,
  QForm,
  QSpace,
  QTable,
  QSelect,
  QTd,
  QCard,
  QDialog,
  QTabPanel,
  QTabPanels,
  QCardSection,
  QAvatar,
  QTabs,
  QEditor,
  QDate,
  QPopupProxy,
  QRadio,
  QInnerLoading,
  QSpinnerDots,
  QSeparator,
  QCheckbox,
  QTimeline,
  QTimelineEntry,
  QTab,
  QTr,
  QTh,
  QUploader,
  QChip,
  QField,
  QRouteTab,
  QCardActions,
  QPopupEdit,
  QInput
} from 'quasar';

Vue.use(Quasar, {
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QEditor,
    QDate,
    QPopupProxy,
    QCheckbox,
    QTabs,
    QTab,
    QTr,
    QTh,
    QRouteTab,
    QTabPanel,
    QTabPanels,
    QPageContainer,
    QPopupEdit,
    QPage,
    QMarkupTable,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QField,
    QList,
    QItem,
    QChip,
    QSeparator,
    QTimeline,
    QAvatar,
    QTimelineEntry,
    QInnerLoading,
    QSpinnerDots,
    QItemSection,
    QUploader,
    QForm,
    QRadio,
    QInput,
    QSpace,
    QTable,
    QSelect,
    QTd,
    QCard,
    QDialog,
    QCardSection,
    QCardActions,
    QItemLabel
  },
  directives: [
    'ClosePopup'
  ],
  lang: lang,
  extras: [
    'material-icons'
  ]
});
